import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import { NumericPatternMaskProps } from '../FormNumericField.types';

export const NumericPatternMask = forwardRef<HTMLInputElement, NumericPatternMaskProps>(({ onChange, ...props }, ref) => {
    /**
     * This handles the callback to our input element onChange.
     * We have to construct a psuedo change event manually to
     * pass it to the input element onChange.
     */
    const handleAccept = (value: string, masked: any) => {
        if (onChange) {
            const event = {
                ...masked.el,
                target: {
                    ...masked.el,
                    value: value,
                    selectionEnd: masked._selection.end,
                },
            };

            onChange(event as React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>);
        }
    };

    /**
     * This is a generic RegExp to match any number of digits so that the numeric field
     * only allows numbers and not any other types of input values.
     */
    const numericPatternMatch: RegExp = /(?:^\d*$)|(?:^$)/;

    return (
        <IMaskInput
            {...props}
            mask={numericPatternMatch}
            inputRef={ref}
            onAccept={handleAccept}
        />
    );
});